export default function ({ store, redirect }) {
  if (store.getters.auth) {
    if (new Date(store.getters.auth.jwt_expired) < new Date(Date.now())) {
      store.dispatch("clearAuth", redirect);
    }
  } else {
    return redirect("/#login");
  }
}
